export default "__VITE_ASSET__BTp98B3e__"